import {
    HTTP
} from '../http-common'

import main from './main'

export default {
    state: {
        error: false,
        loading: false,
        reminderData: [],
        reminderDialog: false,
        megogoList: [],
        youtvList: [],

    },
    mutations: {
        setReminderData(state, payload){
            state.reminderData = payload
        },
        setReminderDialog(state, payload){
            state.reminderDialog = payload
        },
        setMegogoList(state, payload) {
            state.megogoList = payload
        },
        setYoutvList(state, payload) {
            state.youtvList = payload
        },
    },
    actions: {
        buy({
            commit,
            state,
            dispatch
        }, data) {
            state.loading = true
            return new Promise((resolve, reject) => {
                HTTP.post('/megogo/buy', data)
                    .then(response => {
                        state.loading = false
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },
        verifyBuy({
            commit,
            state,
            dispatch
        }, data) {
            state.loading = true
            return new Promise((resolve, reject) => {
                HTTP.post('/megogo/verify-buy', data)
                    .then(response => {
                        state.loading = false
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },
        getMyShops({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                main.state.loading = true
                HTTP.post('/megogo/my-shops/')
                    .then(response => {
                        if (response.data && response.data.content) {
                            resolve(response.data.content)
                            main.state.loading = false
                        } else {
                            resolve([])
                            main.state.loading = false
                        }
                    })
                    .catch(e => {
                        main.state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        resendCODE({
            commit,
            state,
            dispatch
        }, data){
            return new Promise((resolve, reject) => {
                HTTP.post('/megogo/resend-code', data)
                    .then(response => {
                        state.loading = false
                        resolve(response.data.content)
                        dispatch('setSnackbar', ['info', 'Код активації Megogo надіслано повторно'])
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        dispatch('setSnackbar', ['error', error.response.data.error.message])
                        reject(error)
                    })
            })
        },
        getCodesByPhone({
            commit,
            state,
            dispatch
        }, data){
            return new Promise((resolve, reject) => {
                HTTP.post('/megogo/reminder-data', data)
                    .then(response => {
                        state.loading = false
                        commit('setReminderData', response.data.content)
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },
        remindeCode({
            commit,
            state,
            dispatch
        }, data){
            return new Promise((resolve, reject) => {
                HTTP.post('/megogo/reminde-code', data)
                    .then(response => {
                        state.loading = false
                        commit('setReminderDialog', false)
                        if(response.data && response.data.content && response.data.content.sended) {
                            dispatch('setSnackbar', ['info', 'Код активації Megogo надіслано'])
                        } else {
                            dispatch('setSnackbar', ['error', 'Код активації Megogo не надіслано'])
                        }
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },
        userClarification
        ({
            commit,
            state,
            dispatch
        }, data){
            return new Promise((resolve, reject) => {
                HTTP.post('/megogo/user-clarification', data)
                    .then(response => {
                        state.loading = false
                        if (response.data.content && response.data.content.status) {
                            dispatch('setSnackbar', ['info', 'Ваше звернення відправлено'])
                        } else {
                            dispatch('setSnackbar', ['error', 'Будь ласка, вкажіть серійний номер iншого товару'])
                        }
                        resolve(response.data.content)
                    })
                    .catch(error => {
                        state.loading = false
                        state.error = true
                        reject(error)
                    })
            })
        },       
        megogoList({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                state.loading = true
                HTTP.get('/megogo/list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setMegogoList', response.data.content)
                            resolve(response.data.content)
                            state.loading = false
                        } else {
                            commit('setMegogoList', [])
                            resolve([])
                            state.loading = false
                        }
                    })
                    .catch(e => {
                        state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        },
        yuotvList({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                state.loading = true
                HTTP.get('/youtv/list')
                    .then(response => {
                        if (response.data && response.data.content) {
                            commit('setYoutvList', response.data.content)
                            resolve(response.data.content)
                            state.loading = false
                        } else {
                            commit('setYoutvList', [])
                            resolve([])
                            state.loading = false
                        }
                    })
                    .catch(e => {
                        state.loading = false
                        console.error(e)
                        reject(e)
                    })
            })
        }
   
    },   
    
    getters: {
    }
}